var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"rkm-navbar"},[_c('div',{staticClass:"rkm-navbar-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }